.input {
    composes: fontSH48 from "../../styles/typography.module.scss";
    flex-grow: 1;
    position: relative;

    input {
        border: none;
        border-bottom: 1px solid var(--mid-gray);
        font: inherit;
        width: 100%;
        padding-bottom: var(--spacer-16);

        &:focus {
            border-bottom-color: var(--black);
        }

        &::-webkit-search-cancel-button {
            display: none;
        }

        &:placeholder-shown {
            color: var(--dark-gray);
        }

        &:focus-visible {
            outline: none;
        }
    }

    button {
        position: absolute;
        inset-block: auto;
        right: 0;
    }
}
